'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _ramda = require('ramda');
var _reduxForm = require('redux-form');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _subscriptions = require('../../redux/modules/subscriptions');
var _messageModal = require('../../redux/modules/messageModal');
var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _constants = require('../../constants');

var _UnsubscribeSMSPage = require('./UnsubscribeSMSPage.scss');var styles = _interopRequireWildcard(_UnsubscribeSMSPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var UnsubscribeSMSPage = function (_React$Component) {_inherits(UnsubscribeSMSPage, _React$Component);function UnsubscribeSMSPage() {var _temp, _this, _ret;_classCallCheck(this, UnsubscribeSMSPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.

































    clearPhoneValue = function () {var phone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return phone.startsWith('0') ?
      phone.replace(/^0/, _constants.israelCode) :
      phone;}, _this.

    sendRequest = function (values) {
      var phone = _this.clearPhoneValue(values.phone);
      _this.unsubscribe(phone);
    }, _this.

    unsubscribe = function (phone) {var
      topicId = _this.props.routeParams.topicId;
      _this.props.unsubscribeFromTopicByPhone({ phone: phone, topic_id: topicId });
    }, _this.

    renderField = function (_ref) {var input = _ref.input,meta = _ref.meta;return (
        _react2.default.createElement('input', _extends({},
        input, {
          type: 'tel',
          placeholder: _this.props.translate('editOwner', 'phone_number') + ' *',
          className: (0, _classnames2.default)('form-control', { 'has-error': meta.error && !meta.active && meta.touched, touched: meta.touched }) })));}, _temp), _possibleConstructorReturn(_this, _ret);}UnsubscribeSMSPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var isMessageModalOpen = nextProps.isMessageModalOpen,_nextProps$subscripti = nextProps.subscriptions,sent = _nextProps$subscripti.sent,error = _nextProps$subscripti.error;var _props$subscriptions = this.props.subscriptions,oldSent = _props$subscriptions.sent,oldError = _props$subscriptions.error;if (sent && !oldSent || error && !oldError) {var messageKey = sent ? 'successMessage' : 'errorMessage';var additionalMessage = !!error && _react2.default.createElement('div', null, this.props.translate('publishProperty', 'contactTo'), _react2.default.createElement('a', { href: 'mailto:' + _constants.supportEmail, className: 'link' }, ' ' + _constants.supportEmail));this.props.openMessageModal({ isCloseButtonInvisible: false, message: _react2.default.createElement('div', { className: (0, _classnames2.default)({ successMessage: !error }) }, _react2.default.createElement('div', null, this.props.translate('unsubscribe', messageKey)), additionalMessage) });}if (!isMessageModalOpen && this.props.isMessageModalOpen && !error) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(this.props.locale, '/'));}};UnsubscribeSMSPage.prototype.componentWillUnmount = function componentWillUnmount() {this.props.resetSubscriptionState();};UnsubscribeSMSPage.prototype.



  render = function render() {var _props =
    this.props,translate = _props.translate,locale = _props.locale,sending = _props.subscriptions.sending;
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.notFoundWrapper, 'pageHeight') },
        _react2.default.createElement(_reactHelmet2.default, null,
          _react2.default.createElement('meta', { name: 'robots', content: 'noindex,nofollow' })),


        _react2.default.createElement(_reduxForm.Form, { className: styles.content, onSubmit: this.props.handleSubmit(this.sendRequest) },
          _react2.default.createElement('div', null, translate('unsubscribe', 'messagePhone')),
          _react2.default.createElement('div', { className: styles.inputBlock },
            _react2.default.createElement(_reduxForm.Field, {
              name: 'phone',
              component: this.renderField,
              normalize: function normalize(value) {return value.replace(/[\D]/g, '');},
              validate: [_reduxFormValidators.required, _reduxFormValidators.phoneNumber] })),


          _react2.default.createElement('div', { className: styles.buttons },
            _react2.default.createElement('button', { type: 'submit', disabled: sending, className: 'btn btn-primary' },
              sending ?
              _react2.default.createElement('i', { className: (0, _classnames2.default)('icon icon-om-spinner om-pulse', styles.spinner) }) :
              translate('unsubscribe', 'confirm')),


            _react2.default.createElement('a', { href: (0, _appendLocale2.default)(locale, '/'), className: 'btn btn-default' }, translate('unsubscribe', 'cancel'))))));




  };return UnsubscribeSMSPage;}(_react2.default.Component);


UnsubscribeSMSPage.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  routeParams: _propTypes2.default.object,
  subscriptions: _propTypes2.default.object,
  unsubscribeFromTopicByPhone: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  isMessageModalOpen: _propTypes2.default.bool,
  resetSubscriptionState: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func };


var mapDispatchToProps = {
  unsubscribeFromTopicByPhone: _subscriptions.unsubscribeFromTopicByPhone,
  openMessageModal: _messageModal.openMessageModal,
  resetSubscriptionState: _subscriptions.resetSubscriptionState };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    subscriptions: state.subscriptions,
    isMessageModalOpen: state.messageModal.isMessageModalOpen };};


// export default connect(mapStateToProps, mapDispatchToProps)(
//   UnsubscribeSMSPage
// );
exports.default =
(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps),
(0, _reduxForm.reduxForm)({
  form: 'unsubscribe_phone' }))(

UnsubscribeSMSPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/UnsubscribeSMSPage/UnsubscribeSMSPage.js
// module id = 3113
// module chunks = 0